/**
 * `/` — where a signed-in user lands.
 *
 * A workspace with something connected goes straight to the dashboard; only a
 * workspace with nothing connected yet gets the setup wizard. Keeping the
 * choice here means every arrival path agrees on it — email sign-in, the
 * social callback, and a bookmark of the root all route through `/`.
 */
import { Navigate } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { useConnectionStatus } from '@/lib/connections';

export function LandingRoute() {
  const { connected, isLoading } = useConnectionStatus();

  // Placeholder rather than a redirect while the answer is still unknown —
  // guessing here would flash the wrong page on every sign-in.
  if (isLoading) {
    return (
      <div className="space-y-2.5">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-5 w-80" />
      </div>
    );
  }

  return <Navigate to={connected ? '/dashboard' : '/onboarding'} replace />;
}
